import { createFileRoute } from "@tanstack/react-router";
import { InspirationPage } from "@/features/inspiration/inspiration-page";

export const Route = createFileRoute("/app/w/$weddingId/inspiration")({ component: InspirationPage });
